import { render, staticRenderFns } from "./TasksArchive.vue?vue&type=template&id=590e141a&"
import script from "./TasksArchive.vue?vue&type=script&lang=js&"
export * from "./TasksArchive.vue?vue&type=script&lang=js&"
import style0 from "./TasksArchive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports